import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-surface border-t border-dark-border mt-auto">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-8 sm:py-12">
        {/* Footer Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-12">
          {/* Brand Column */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-3">
              <div className="w-8 h-8 flex items-center justify-center">
                <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
                  <rect x="2" y="8" width="6" height="20" rx="1" fill="#d4a012"/>
                  <rect x="11" y="14" width="6" height="14" rx="1" fill="#d4a012" opacity="0.7"/>
                  <rect x="20" y="6" width="6" height="22" rx="1" fill="#d4a012"/>
                  <rect x="29" y="12" width="6" height="16" rx="1" fill="#d4a012" opacity="0.7"/>
                  <path d="M5 18L14 12L23 16L32 8" stroke="#26a269" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <circle cx="32" cy="8" r="3" fill="#26a269"/>
                </svg>
              </div>
              <span className="font-mono text-base font-semibold tracking-tight text-dark-text">
                DayTrading<span className="text-accent-gold">Bench</span>
              </span>
            </Link>
            <p className="text-sm text-dark-text-secondary mb-4">
              Benchmarking LLM trading performance with real market data.
            </p>
            <p className="text-xs text-dark-text-secondary">
              © {currentYear} DayTradingBench
            </p>
          </div>

          {/* Product Column */}
          <div>
            <h3 className="text-sm font-semibold text-dark-text mb-4">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-dark-text-secondary hover:text-dark-text transition-colors"
                >
                  Leaderboard
                </Link>
              </li>
              <li>
                <Link
                  to="/docs"
                  className="text-sm text-dark-text-secondary hover:text-dark-text transition-colors"
                >
                  Documentation
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h3 className="text-sm font-semibold text-dark-text mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/terms"
                  rel="nofollow"
                  className="text-sm text-dark-text-secondary hover:text-dark-text transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  rel="nofollow"
                  className="text-sm text-dark-text-secondary hover:text-dark-text transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <a
                  href="mailto:contact@daytradingbench.com"
                  className="text-sm text-dark-text-secondary hover:text-dark-text transition-colors"
                >
                  contact@daytradingbench.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
